import Report from '@/core/report'
import { reportToBoss } from '@/core/jsapi'
const report1 = new Report({ actid: 202 })

const report = {
  send(subType: string, kv = {}) {
    // atta
    report1.send({
      pagename: 'gh_firework',
      // eslint-disable-next-line @typescript-eslint/camelcase
      event_id: `gh_firework_${subType}`,
      kv
    })

    reportToBoss('gh_firework', {
      subType,
      kv
    })
  }
}

export default report
